import { CoreIcon } from '../core-icon';
import downloadSVG from '../../../src/images/icons/download.svg';

export const DownloadIcon = props => {
  return <CoreIcon src={downloadSVG} {...props} />;
};
